import { Button, Notification, Select, SelectOption, Spinner } from "@rio-cloud/rio-uikit";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SubNavigation from '@rio-cloud/rio-uikit/SubNavigation';
import { useEffect, useState } from "react";
import CardInfo from "./components/CardInfo";
import CardStatus, { UserTas } from "./components/CardStatus";
import Occurrence from "./components/Occurrence";
import AdditionalData from "./components/AdditionalData";
import { edithOccurrencesDetail, fetchOccurrencesDetail, fetchSupportLogs, fetchSupportRegionals, fetchSupportVehicle, fetchUsers } from "../../../../api/tas";
import { IOccurrence, LogOccurence, OccurrenceStatus, VehicleSupport } from "../../types";
import moment from 'moment';
import { typeStatusOccurence } from "../../constants";
import { ChatOccurrenceTas } from "../chat";
import { useIntl } from "react-intl";
import { fetchUserRole } from "../../../../api/fetchUser";
import SupportAttachmentsPage from "../Attachments";
import VehicleData from "./components/VehiclesData";
import AdditionalDataTas from "./components/AditionalDataTas";
import SupportHistoryPage from "../supportHistory";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";

export type ErrorsType = {
    responsible: boolean;
    dn: boolean;
    chassis?: boolean;
    licensePlate?: boolean;
    customer?: boolean;
    dnResponsible: boolean;
    entryDate?: boolean;
    phone?: boolean;
    odometer?: boolean;
    hourMeter?: boolean;
    selectedRegional: boolean;
    customerComment?: boolean;
    partName?: boolean;
    aeg?: boolean;
    diagnose?: boolean;
    repair?: boolean;
    analysisReason?: boolean;
    cancelComment?: boolean,
    vehicleQtd?: boolean,
    partOrComponentName?: boolean;
    partNumber?: boolean;
    problemDescription?: boolean;
    diagnosticAndResults?: boolean;
    problemSteps?: boolean;
    failureFrequency?: boolean;
    cancelReason?: boolean;
}

const SupportDetailsPage = () => {
    const navigate = useNavigate();
    const intl = useIntl();
    const location = useLocation();
    const [selected, setSelected] = useState<undefined | string[]>(undefined);
    const [data, setData] = useState<IOccurrence | undefined>(undefined);
    const [responsible, setResponsible] = useState('');
    const [dn, setDn] = useState('');
    const [chassis, setChassis] = useState('');
    const [licensePlate, setLicensePlate] = useState('');
    const [customer, setCustomer] = useState('');
    const [dnResponsible, setDnResponsible] = useState('');
    const [hourMeter, setHourMeter] = useState(0);
    const [odometer, setOdometer] = useState(0);
    const [entryDate, setEntryDate] = useState('');
    const [isLoadingEdit, setIsLoadingEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState<UserTas[]>([]);
    const [selectedUser, setSelectedUser] = useState<undefined | string[]>(undefined);
    const [selectedUserName, setSelectedUserName] = useState<string>('')
    const [isControlTower, setIsControlTower] = useState(false);
    const [isConsultant, setIsConsultant] = useState(false);
    const [optionsRegionals, setOptionsRegionals] = useState<SelectOption[]>([]);
    const [selectedRegional, setSelectedRegional] = useState<undefined | string[]>(undefined);
    const [customerComment, setCustomerComment] = useState('');
    const [diagnose, setDiagnose] = useState('');
    const [repair, setRepair] = useState('');
    const [analysisReason, setAnalysisReason] = useState('');
    const [partName, setPartName] = useState('');
    const [aeg, setAeg] = useState('');
    const [phone, setPhone] = useState('');
    const [vehicleQtd, setVehicleQtd] = useState('');
    const [cancelComment, setCancelComment] = useState('');
    const [partOrComponentName, setPartOrComponentName] = useState('');
    const [partNumber, setPartNumber] = useState('');
    const [problemDescription, setProblemDescription] = useState('');
    const [diagnosticAndResults, setDiagnosticAndResults] = useState('');
    const [problemSteps, setProblemSteps] = useState('');
    const [failureFrequency, setFailureFrequency] = useState('');
    const [vehicle, setVehicle] = useState<VehicleSupport | null>(null);
    const [isLoadingChassis, setIsLoadingChassis] = useState(false);
    const [cancelReason, setCancelReason] = useState('');

    //LOGS
    const [logOccurence, setLogOccurence] = useState<LogOccurence[]>([]);
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [status, setStatus] = useState<undefined | string[]>(undefined);
    const [userSearch, setUserSearch] = useState('');
    const [isLoadingLogs, setIsLoadingLogs] = useState(false);

    const initialErrors: ErrorsType = {
        responsible: false,
        dn: false,
        dnResponsible: false,
        entryDate: false,
        chassis: false,
        phone: false,
        licensePlate: false,
        customer: false,
        odometer: false,
        hourMeter: false,
        selectedRegional: false,
        customerComment: false,
        partName: false,
        aeg: false,
        diagnose: false,
        repair: false,
        analysisReason: false,
        cancelComment: false,
        vehicleQtd: false,
        partOrComponentName: false,
        partNumber: false,
        problemDescription: false,
        diagnosticAndResults: false,
        problemSteps: false,
        failureFrequency: false,
        cancelReason: false,
    };

    const [errors, setErrors] = useState<ErrorsType>(initialErrors);

    const handleGoBack = () => {
        navigate(-1);
    };

    const [searchParams] = useSearchParams();

    const id = searchParams.get("id");

    const tab = searchParams.get("tab");

    const activeTab = (() => {
        if (tab === "chat") {
            return "chat";
        }

        if (tab === 'attachments') {
            return "attachments";
        }

        if (tab === 'supportHistory') {
            return "supportHistory";
        }

        return "summary";
    })();

    const tabPath = (tab: "summary" | "chat" | 'attachments' | 'supportHistory') => {
        const params = new URLSearchParams(searchParams);
        if (tab === "chat") {
            params.set("tab", "chat");
        } else if (tab === "attachments") {
            params.set('tab', "attachments")
        } else if (tab === "supportHistory") {
            params.set('tab', "supportHistory")
        } else {
            params.delete("tab");
        }
        const query = params.toString();
        return `${location.pathname}${query ? `?${query}` : ""}`;
    };

    const handleCheckInput = () => {
        const fields: ErrorsType = {
            responsible: !responsible,
            dn: !dn,
            dnResponsible: !dnResponsible,
            selectedRegional: !selectedRegional?.[0],
            phone: !phone,
            ...(data?.subject === 'TECHNICAL' && {
                chassis: chassis?.length !== 17,
                licensePlate: !licensePlate,
                customer: !customer,
                odometer: !odometer,
                hourMeter: !hourMeter,
                customerComment: !customerComment,
                partName: !partName,
                diagnose: !diagnose,
                repair: !repair,
                analysisReason: !analysisReason,
                entryDate: !moment(entryDate).isValid(),
            }),

            ...(data?.subject === 'CONTRACT_CANCELLATION' && {
                cancelComment: !cancelComment,
                vehicleQtd: !vehicleQtd,
                cancelReason: !cancelReason,
            }),
        };

        setErrors(fields);

        return !Object.values(fields).some(Boolean);
    };

    const fetchRegionals = async () => {
        const res = await fetchSupportRegionals();
        if (res?.content) {
            setOptionsRegionals(res?.content?.map((res: { id: number, name: string }) => {
                return {
                    id: res.id.toString(),
                    label: res.name,
                }
            }))
        }
    };

    const fetchOccurrencesDetails = async () => {
        setIsLoading(true);

        try {
            if (!id) {
                throw new Error('NO_DATA');
            };

            const res = await fetchOccurrencesDetail(id);
            setSelected([res.status]);
            setData(res);
            setResponsible(res.responsible);
            setDn(res.dn);
            setChassis(res.chassis);
            setLicensePlate(res.licensePlate);
            setCustomer(res.customer);
            setDnResponsible(res.dnResponsible);
            setHourMeter(res.hourMeter);
            setOdometer(res.odometer);
            setEntryDate(res.entryDate ? moment(res.entryDate).format('YYYY-MM-DD') : '');
            setSelectedUser([res.assignedToId]);
            setSelectedUserName(res.assignedTo);
            setSelectedRegional(res.regionalId ? [res.regionalId?.toString()] : undefined);
            setCustomerComment(res.customerComment);
            setDiagnose(res.diagnose);
            setRepair(res.repair);
            setAnalysisReason(res.analysisReason);
            setPartName(res.partName);
            setAeg(res.aeg);
            setPhone(res.phone)
            setCancelComment(res.cancelComment);
            setVehicleQtd(res.vehicleQtd?.toString())
            setPartOrComponentName(res.partOrComponentName);
            setPartNumber(res.partNumber)
            setProblemDescription(res.problemDescription);
            setDiagnosticAndResults(res.diagnosticAndResults);
            setProblemSteps(res.problemSteps);
            setFailureFrequency(res.failureFrequency);
            setCancelReason(res.cancelReason);

        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }

    const fetchUsersList = async () => {
        const res = await fetchUsers({searchTerm: undefined, subject: data?.subject, subtopic: data?.subtopic});
        const transformed = res.map((user: { id: string, firstName: string, lastName: string }) => {
            return {
                id: user.id,
                label: `${user.firstName} ${user.lastName}`
            }
        })
        setUsers(transformed);
    }

    const fetchRole = async () => {
        const role = await fetchUserRole();
        setIsControlTower(role === 'TOWER');
        setIsConsultant(role === 'CONSULTANT' || role === 'GROUP_CONSULTANT');
    };

    const fetchVehicle = async () => {
        setIsLoadingChassis(true);

        try {
            const res = await fetchSupportVehicle(chassis);
            setVehicle(res);
            if (res?.licensePlate) {
                setLicensePlate(res.licensePlate);
            };

        } catch (error) {
            setVehicle(null);
        } finally {
            setIsLoadingChassis(false);
        }
    }

    const normalizeValue = (value: unknown) => {
        if (
            value === null ||
            value === undefined ||
            (typeof value === "string" && value.trim() === "")
        ) {
            return null;
        }

        return value;
    };

    const fetchLogs = async () => {
        setIsLoadingLogs(true);

        if (!id) {
            return;
        }

        try {
            const isEmptyValue = (value: unknown) => {
                return (
                    value === null ||
                    value === undefined ||
                    value === "" ||
                    value === 0 ||
                    value === "0"
                );
            };

            const ignoredFields = [
                "id",
                "createdBy",
                "createdById",
                "updatedById",
                "statusUpdatedAt",
                "createdAt",
                "updatedAt",
                "tasOccurrenceNumber",
                "assignedToId",
            ];


            const res = await fetchSupportLogs({
                id,
                searchTerm: status?.[0] || undefined,
                userName: userSearch,
                endDate: `${endDate}T23:59:00Z`,
                startDate: `${startDate}T00:00:00Z`,
            });

            // Apenas criação da ocorrência principal
            const occurrenceCreate = res?.content?.find(
                (item: { action: string; entity: string }) =>
                    item.action === "CREATE" &&
                    item.entity === "TAS_OCCURRENCE"
            );

            const statusCreate = occurrenceCreate?.data?.find(
                (item: {
                    input: string;
                    newData?: string | number;
                    oldData?: string | number | null;
                }) => item.input === "status"
            );

            const start: LogOccurence[] = occurrenceCreate
                ? [
                    {
                        action: "CREATE",
                        createdAt: occurrenceCreate.createdAt,
                        fieldChanged: "Ocorrência criada",
                        id: occurrenceCreate.id,
                        old: "",
                        new: "",
                        status: statusCreate?.newData ?? "",
                        user: occurrenceCreate.userName,
                    },
                ]
                : [];

            const changes: LogOccurence[] = res?.content?.flatMap(
                (log: {
                    id: number;
                    action: string;
                    entity: string;
                    createdAt: string;
                    userName: string;
                    description: string;
                    oldData?: any;
                    newData?: any;
                    data: {
                        input: string;
                        oldData?: string | number | null;
                        newData?: string | number | null;
                    }[];
                }) => {
                    // CREATE da ocorrência principal já foi tratado em start
                    if (
                        log.action === "CREATE" &&
                        log.entity === "TAS_OCCURRENCE"
                    ) {
                        return [];
                    }

                    // CREATE COMMENT
                    if (
                        log.action === "CREATE" &&
                        log.entity === "TAS_OCCURRENCE_COMMENT"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Comentário criado",
                                id: log.id,
                                old: "",
                                new: log.newData?.comment ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // CREATE FILE
                    if (
                        log.action === "CREATE" &&
                        log.entity === "TAS_OCCURRENCE_FILE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Arquivo anexado",
                                id: log.id,
                                old: "",
                                new: log.newData?.name ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // UPDATE COMMENT
                    if (
                        log.action === "UPDATE" &&
                        log.entity === "TAS_OCCURRENCE_COMMENT"
                    ) {
                        const commentChange = log.data.find(
                            item => item.input === "comment"
                        );

                        if (!commentChange) {
                            return [];
                        }

                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Comentário editado",
                                id: log.id,
                                old: commentChange.oldData ?? "",
                                new: commentChange.newData ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // UPDATE FILE
                    if (
                        log.action === "UPDATE" &&
                        log.entity === "TAS_OCCURRENCE_FILE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Arquivo atualizado",
                                id: log.id,
                                old: log.oldData?.name ?? "",
                                new: log.newData?.name ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // UPDATE OCCURRENCE
                    if (
                        log.action === "UPDATE" &&
                        log.entity === "TAS_OCCURRENCE"
                    ) {
                        return log.data
                            .filter(item => {
                                if (ignoredFields.includes(item.input)) {
                                    return false;
                                }

                                if (
                                    isEmptyValue(item.oldData) &&
                                    isEmptyValue(item.newData)
                                ) {
                                    return false;
                                }

                                return item.oldData !== item.newData;
                            })
                            .map(item => ({
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: item.input,
                                id: log.id,
                                old: item.oldData ?? "",
                                new: item.newData ?? "",
                                status: log.description,
                                user: log.userName,
                            }));
                    }

                    // DELETE COMMENT
                    if (
                        log.action === "DELETE" &&
                        log.entity === "TAS_OCCURRENCE_COMMENT"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Comentário removido",
                                id: log.id,
                                old: "",
                                new: "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // DELETE FILE
                    if (
                        log.action === "DELETE" &&
                        log.entity === "TAS_OCCURRENCE_FILE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Arquivo removido",
                                id: log.id,
                                old: "",
                                new: log.oldData?.name ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // DELETE OCCURRENCE
                    if (
                        log.action === "DELETE" &&
                        log.entity === "TAS_OCCURRENCE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "Ocorrência removida",
                                id: log.id,
                                old: "",
                                new: "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    return [];
                }
            );

            const logs = [...start, ...changes];

            logs.sort(
                (a, b) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
            );

            setLogOccurence(logs);
        } catch (error) {
            setLogOccurence([]);
        } finally {
            setIsLoadingLogs(false);
        }
    };

    useEffect(() => {
        fetchRole();
        fetchRegionals();
        fetchOccurrencesDetails();
    }, [id]);


    useEffect(() => {
        if (data?.subject && data.subtopic) {
            fetchUsersList();
        }
    }, [data?.subject, data?.subtopic])

    useEffect(() => {
        if (activeTab === 'supportHistory') {
            fetchLogs();
        }
    }, [id, activeTab])


    useEffect(() => {
        if (chassis?.length === 17) {
            fetchVehicle();
        }
    }, [chassis]);


    const handleEdit = async () => {
        setIsLoadingEdit(true);

        // const isError = handleCheckInput();

        // if (!isError) {
        //     setIsLoadingEdit(false);
        //     return;
        // }

        try {
            if (!id || !data) {
                throw new Error('NO DATA')
            }

            await edithOccurrencesDetail(id, {
                ...data,
                responsible: responsible,
                dn: dn,
                chassis: chassis,
                licensePlate: licensePlate,
                customer: customer,
                dnResponsible: dnResponsible,
                hourMeter: hourMeter,
                odometer: odometer,
                entryDate: moment(entryDate).isValid() ? `${entryDate}T03:00:00Z` : null,
                statusUpdatedAt: data.status === selected?.[0] ? data.statusUpdatedAt : moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                status: selected?.[0] as OccurrenceStatus,
                assignedToId: selectedUser?.[0] || null,
                assignedTo: selectedUserName || null,
                regionalId: selectedRegional?.[0] ? Number(selectedRegional?.[0]) : null,
                customerComment: customerComment,
                diagnose: diagnose,
                repair: repair,
                analysisReason: analysisReason,
                partName: partName,
                aeg: aeg,
                vehicleQtd: Number(vehicleQtd) || 0,
                cancelComment: cancelComment,
                partOrComponentName: partOrComponentName,
                partNumber: Number(partNumber) || 0,
                problemDescription: problemDescription,
                diagnosticAndResults: diagnosticAndResults,
                problemSteps: problemSteps,
                failureFrequency: failureFrequency,
                phone: phone,
                cancelReason: cancelReason,
            });
            Notification.success('Editado com sucesso');
            navigate(-1);
        } catch (error) {
            Notification.error('Não foi possível editar no momento')
        } finally {
            setIsLoadingEdit(false);
        }
    };

    const handleSelectedUser = (u?: UserTas) => {
        setSelectedUser([u?.id || '']);
        setSelectedUserName(u?.label || '');
    };

    const handleApplyFilterLog = () => {
        fetchLogs();
    }

    const disabledMove = isConsultant ? data?.status === 'ANSWERED' ? false : true : !isControlTower;

    return (
        <div className="width-100pct height-100pct display-flex justify-content-center align-items-center">
            <div className="panel panel-default panel-body height-100pct shadow-default margin-top-20" style={{ width: 1400 }}>
                <div className="border border-bottom-only padding-y-10" style={{ display: 'flex', alignItems: 'center !important', justifyContent: 'space-between' }}>
                    <span className="text-size-h4 align-self-center">Dados da solicitação</span>
                    <Button bsStyle={Button.MUTED} iconOnly iconName='rioglyph-remove' className="text-color-black" onClick={handleGoBack} />
                </div>

                <div className="width-100pct margin-top-20">
                    <label htmlFor="type">Mover para</label>
                    <Select
                        id="type"
                        bsSize='lg'
                        value={selected}
                        onChange={(item) => setSelected([item?.id as string])}
                        options={typeStatusOccurence.map((type) => {
                            return {
                                ...type,
                                disabled: isConsultant && type.id === 'OPEN',
                            }
                        })}
                        disabled={disabledMove}
                        placeholder="Tipo de busca"
                    />
                </div>

                <div className="width-100pct margin-top-20">
                    <div className="border border-bottom-only margin-top-20">
                        <SubNavigation
                            navItems={[
                                {
                                    key: '1',
                                    route: (
                                        <Link
                                            to={tabPath("summary")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "summary" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "summary" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.summary" })}
                                        </Link>
                                    ),
                                },
                                {
                                    key: '2',
                                    route: (
                                        <Link
                                            to={tabPath("chat")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "chat" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "chat" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.chat" })}
                                        </Link>
                                    ),
                                },

                                {
                                    key: '3',
                                    route: (
                                        <Link
                                            to={tabPath("attachments")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "attachments" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "attachments" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.attachments" })}
                                        </Link>
                                    ),
                                },
                                {
                                    key: '4',
                                    route: useFeatureFlag('tasOccurrenceLogsTab') ?
                                        <Link
                                            to={tabPath("supportHistory")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "supportHistory" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "supportHistory" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.supportHistory" })}
                                        </Link>
                                        : <></>,
                                }
                            ]}
                        />
                    </div>

                    <div className="display-flex width-100pct height-100pct margin-top-20">
                        <div className="flex-1-1 display-flex flex-column justify-content-between">
                            {activeTab === 'summary' && (
                                <>
                                    <div className="width-100pct display-flex" style={{ height: data?.supportType !== 'CONTRACT_CANCELLATION' && data?.supportType !== 'COMMERCIAL' ? 310 : 267.91 }}>
                                        <div className="width-100pct height-100pct">
                                            <CardInfo
                                                subject={data?.subject}
                                                supportType={data?.supportType}
                                                subtopic={data?.subtopic}
                                                createdBy={data?.createdBy}
                                                createdAt={data?.createdAt}
                                                updatedAt={data?.updatedAt}
                                                timeInStatus={data?.timeInStatus}
                                                statusUpdatedAt={data?.statusUpdatedAt}
                                                isLoading={isLoading}
                                            />
                                        </div>
                                        <div className="width-100pct height-100pct">
                                            <CardStatus
                                                status={data?.status}
                                                createdAt={data?.createdAt}
                                                isLoading={isLoading}
                                                users={users}
                                                selectedUser={selectedUser}
                                                handleSelectedUser={handleSelectedUser}
                                                isControlTower={isControlTower}
                                            />
                                        </div>
                                    </div>

                                    <div className="width-100pct">
                                        <Occurrence
                                            isLoading={isLoading}
                                            responsible={responsible}
                                            handleResponsible={(resp) => setResponsible(resp)}
                                            subject={data?.subject}
                                            dn={dn}
                                            handleDn={(dn) => setDn(dn)}
                                            chassis={chassis}
                                            handleChassis={ch => setChassis(ch)}
                                            licensePlate={licensePlate}
                                            handleLicensePlate={lp => setLicensePlate(lp)}
                                            customer={customer}
                                            handleCustomer={cr => setCustomer(cr)}
                                            dnResponsible={dnResponsible}
                                            handleDnResponsible={dn => setDnResponsible(dn)}
                                            hourMeter={hourMeter}
                                            handleHourMeter={hm => setHourMeter(hm)}
                                            odometer={odometer}
                                            handleOdometer={or => setOdometer(or)}
                                            entryDate={entryDate}
                                            handleEntryDate={date => setEntryDate(date)}
                                            errors={errors}
                                            optionsRegionals={optionsRegionals}
                                            selectedRegional={selectedRegional}
                                            handleChangeRegional={(id) => setSelectedRegional([id as string])}
                                            phone={phone}
                                            handlePhone={(ph) => setPhone(ph)}
                                        />
                                    </div>
                                    <div className="width-100pct">
                                        {data?.supportType === 'TECHNICAL_SUPPORT' ? (
                                            <AdditionalDataTas
                                                isLoading={isLoading}
                                                subject={data?.subject}
                                                tasOccurrenceNumber={data?.tasOccurrenceNumber}
                                                customerComment={customerComment}
                                                handleChangeComment={comment => setCustomerComment(comment)}
                                                errors={errors}
                                                partOrComponentName={partOrComponentName}
                                                handlePartOrComponentName={(pn) => setPartOrComponentName(pn)}
                                                partNumber={partNumber}
                                                handlePartNumber={(pn) => setPartNumber(pn)}
                                                problemDescription={problemDescription}
                                                handleProblemDescription={(pd) => setProblemDescription(pd)}
                                                diagnosticAndResults={diagnosticAndResults}
                                                handleDiagnosticAndResults={dr => setDiagnosticAndResults(dr)}
                                                problemSteps={problemSteps}
                                                handleProblemSteps={(ps) => setProblemSteps(ps)}
                                                failureFrequency={failureFrequency}
                                                handleFailureFrequency={fr => setFailureFrequency(fr)}
                                            />
                                        ) : (
                                            <AdditionalData
                                                isLoading={isLoading}
                                                subject={data?.subject}
                                                tasOccurrenceNumber={data?.contractNumber}
                                                customerComment={customerComment}
                                                handleChangeComment={comment => setCustomerComment(comment)}
                                                diagnose={diagnose}
                                                handleDiagnose={d => setDiagnose(d)}
                                                repair={repair}
                                                handleRepair={r => setRepair(r)}
                                                analysisReason={analysisReason}
                                                handleAnalysisReason={ar => setAnalysisReason(ar)}
                                                partName={partName}
                                                handlePartName={pn => setPartName(pn)}
                                                aeg={aeg}
                                                handleAeg={ag => setAeg(ag)}
                                                errors={errors}
                                                cancelComment={cancelComment}
                                                handleCancelComment={cm => setCancelComment(cm)}
                                                vehicleQtd={vehicleQtd}
                                                handleVehicleQtd={qtd => setVehicleQtd(qtd)}
                                                cancelReason={cancelReason}
                                                handleCancelReason={(cancel) => setCancelReason(cancel)}
                                            />
                                        )}
                                    </div>
                                </>
                            )}

                            {activeTab === 'chat' && (
                                <div className="width-100pct">
                                    <ChatOccurrenceTas occurrenceId={id ?? ''} disabled={data?.status === 'FINISHED'} />
                                </div>
                            )}

                            {activeTab === 'attachments' && (
                                <div className="width-100pct">
                                    <SupportAttachmentsPage id={id ?? ''} isControlTower={isControlTower} />
                                </div>
                            )}

                            {activeTab === 'supportHistory' && (
                                <div className="width-100pct">
                                    <SupportHistoryPage
                                        data={logOccurence}
                                        handleStartDate={start => setStartDate(start)}
                                        handleEndDate={end => setEndDate(end)}
                                        startDate={startDate}
                                        endDate={endDate}
                                        handleStatus={c => setStatus(c)}
                                        status={status}
                                        handleUser={e => setUserSearch(e)}
                                        user={userSearch}
                                        handleSubmit={handleApplyFilterLog}
                                        isLoading={isLoadingLogs}
                                    />
                                </div>
                            )}
                        </div>

                        {activeTab === 'summary' && useFeatureFlag('tasOccurrenceVehicleContainer') && (
                            <div className="min-width-400 height-100pct">
                                <VehicleData data={vehicle} isLoading={isLoadingChassis} />
                            </div>
                        )}
                    </div>

                    <div className="width-100pct margin-top-20 display-flex justify-content-end">
                        <Button onClick={handleGoBack}>Cancelar</Button>
                        <button className={`btn btn-primary ${isLoadingEdit ? 'btn-loading disabled' : ''}`} type="button" disabled={isLoadingEdit || isLoading} onClick={handleEdit}>Salvar alterações</button>
                    </div>

                </div>
            </div>
        </div>
    )
};

export default SupportDetailsPage;